var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataDetailRef",
          attrs: {
            size: "small",
            model: _vm.dataDetail,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("home.HolidayName"),
                        prop: "name",
                        rules: {
                          required: true,
                          message: this.$t("CenterForSorting.notNull"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                        },
                        model: {
                          value: _vm.dataDetail.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataDetail, "name", $$v)
                          },
                          expression: "dataDetail.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("operationCenter.SelectDate"),
                        prop: "date",
                        rules: {
                          required: true,
                          message: this.$t("CenterForSorting.notNull"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "-",
                          "value-format": "yyyy-MM-dd",
                          "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                          "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                        },
                        model: {
                          value: _vm.dataDetail.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataDetail, "date", $$v)
                          },
                          expression: "dataDetail.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("home.HolidayType"),
                        prop: "type",
                        rules: {
                          required: true,
                          message: this.$t("CenterForSorting.notNull"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            clearable: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeType(_vm.dataDetail.type)
                            },
                          },
                          model: {
                            value: _vm.dataDetail.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataDetail, "type", $$v)
                            },
                            expression: "dataDetail.type",
                          },
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: {
                              label: _vm.$t("home.NationalHoliday"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            key: 2,
                            attrs: {
                              label: _vm.$t("home.LocalHoliday"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.dataDetail.type === 2
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.SelectStateCity"),
                            prop: "targetLocations",
                            rules: {
                              required: _vm.dataDetail.type === 2,
                              message: this.$t("CenterForSorting.notNull"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.processedStateCityOptions,
                              props: _vm.cascaderProps,
                              "show-all-levels": false,
                              clearable: "",
                              filterable: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleTargetLocationChange(
                                  _vm.dataDetail.targetLocations
                                )
                              },
                            },
                            model: {
                              value: _vm.dataDetail.targetLocations,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataDetail, "targetLocations", $$v)
                              },
                              expression: "dataDetail.targetLocations",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("orderCenterCont.SelectCustomers"),
                        prop: "targetCustomerIds",
                        rules: {
                          required: true,
                          message: this.$t("CenterForSorting.notNull"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "spareNumberPoo.Only10AreDisplayed"
                            ),
                            "remote-method": _vm.getCustomerPage,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            multiple: "",
                            "reserve-keyword": "",
                            size: "small",
                          },
                          on: {
                            "visible-change": _vm.getCustomerPageList,
                            change: function ($event) {
                              return _vm.changeTargetCustomer()
                            },
                          },
                          model: {
                            value: _vm.dataDetail.targetCustomerIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataDetail, "targetCustomerIds", $$v)
                            },
                            expression: "dataDetail.targetCustomerIds",
                          },
                        },
                        _vm._l(_vm.customerList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.username, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("home.SelectMerchant"),
                        prop: "targetMerchantCodes",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "spareNumberPoo.Only10AreDisplayed"
                            ),
                            "remote-method": _vm.getShanghu,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            multiple: "",
                            "reserve-keyword": "",
                            size: "small",
                          },
                          on: { "visible-change": _vm.getShanghuList },
                          model: {
                            value: _vm.dataDetail.targetMerchantCodes,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dataDetail,
                                "targetMerchantCodes",
                                $$v
                              )
                            },
                            expression: "dataDetail.targetMerchantCodes",
                          },
                        },
                        _vm._l(_vm.commercialList, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }